// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"48c1c7a8","264":"98e68e70","411":"3cb03a8f","570":"27fc5e2a","617":"0fc268b4","877":"2d104d72"}[chunkId] + ".chunk.js";
};